import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaAffix from './VaAffix.vue'

export const VaAffix = withConfigTransport(_VaAffix)
